// extracted by mini-css-extract-plugin
export default {"layout":"structure_layout__HMjHZ","main":"structure_main__o9HCO"};